import { SpiritedTheme } from "../.internal/themes/SpiritedTheme";
export default SpiritedTheme;